export default __webpack_public_path__ + "static/media/office-sto.3f3925f3.svg";